import { createFileRoute } from "@tanstack/react-router"

import WarehouseInfoContainer from "@/screens/Warehouses/components/WarehouseInfo/WarehouseInfoContainer"

export const Route = createFileRoute("/app/admin/warehouses/$warehouseId/_layout/info")({
  component: WarehouseInfoContainer,
})
